module.exports = "<mat-basic-audio-player [audioUrl]=\"audioFileData\" ></mat-basic-audio-player>\n"